import { useEffect, useState } from "react";
import { If } from "../../../components/control-statements";
import { Label } from "../../../components/Label";
import { Checkbox } from "../../../components/Checkbox";

const USE_TYPES = {
  ONLINE: 1,
  OFFLINE: 2,
  TAKEAWAY: 4,
  FASTFILA: 8,
};

const isType = (haystack, needle) => (needle & haystack) >= needle;

export const BenefitUseTypeStepOld = ({ benefit, onChange }) => {
  const [type_use, setUseType] = useState(null);

  useEffect(() => {
    onChange({ ...benefit, type_use });
  }, [type_use]);

  const isFreeDelivery = benefit.type === "FREE_DELIVERY";
  return (
    <>
      <Label
        text={"Onde o benefício poderá ser utilizado?"}
        className={"mb-20"}
      />
      <If cond={!isFreeDelivery}>
        <Checkbox
          label="Salão"
          family="useType"
          className="mb-15"
          checked={isType(type_use, USE_TYPES.OFFLINE)}
          onChange={() =>
            setUseType((previous) => {
              if (isType(previous, USE_TYPES.OFFLINE)) {
                return previous & ~USE_TYPES.OFFLINE;
              } else {
                return previous | USE_TYPES.OFFLINE;
              }
            })
          }
        />
      </If>
      <Checkbox
        label="Delivery"
        family="useType"
        className="mb-15"
        checked={isType(type_use, USE_TYPES.ONLINE)}
        onChange={() =>
          setUseType((previous) => {
            if (isType(previous, USE_TYPES.ONLINE)) {
              return previous & ~USE_TYPES.ONLINE;
            } else {
              return previous | USE_TYPES.ONLINE;
            }
          })
        }
      />
      <If cond={!isFreeDelivery}>
        <Checkbox
          label="Para viagem"
          family="useType"
          className="mb-15"
          checked={isType(type_use, USE_TYPES.TAKEAWAY)}
          onChange={() =>
            setUseType((previous) => {
              if (isType(previous, USE_TYPES.TAKEAWAY)) {
                return previous & ~USE_TYPES.TAKEAWAY;
              } else {
                return previous | USE_TYPES.TAKEAWAY;
              }
            })
          }
        />
      </If>
      <If cond={!isFreeDelivery}>
        <Checkbox
          label="Consumo no local"
          family="useType"
          className="mb-15"
          checked={isType(type_use, USE_TYPES.FASTFILA)}
          onChange={() =>
            setUseType((previous) => {
              if (isType(previous, USE_TYPES.FASTFILA)) {
                return previous & ~USE_TYPES.FASTFILA;
              } else {
                return previous | USE_TYPES.FASTFILA;
              }
            })
          }
        />
      </If>
    </>
  );
};
